<template>
	<div class="page">
		<!-- 筛选 -->
		<div class="filter">
			<el-input placeholder="请输入内容" v-model="keyword" clearable prefix-icon="el-icon-search" class="sousuo"
				size="small">
			</el-input>
			<el-button type="warning" @click="handelComClick" size="small">搜索</el-button>
			<div class="filterName">状态：</div>
			<el-select v-model="transferStatu" placeholder="请选择" class="titleSelect" style="width: 100px;"
				size="small" @change="handelComClick">
				<el-option v-for="item in transferStatus" :key="item.value" :label="item.label"
					:value="item.value" />
			</el-select>
			<div class="filterName">接收门店：</div>
			<el-select v-model="shopId" placeholder="请选择" class="titleSelect" style="width: 100px;"
				size="small" @change="handelComClick">
				<el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<div class="filterName">转移日期：</div>
			<el-date-picker v-model="comDate" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" size="small" style="width: 220px;" @change="handelComClick">
			</el-date-picker>
			<el-button type="warning" plain size="small" style="margin-left: 20px;" @click="resetClick">重置</el-button>
		</div>
		<!-- 表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="insideName" label="名称" width="120">
				<template slot-scope="scope">
					{{scope.row.insideName == null?'--':scope.row.insideName}}
				</template>
			</el-table-column>
			<el-table-column prop="petApplyType.title" label="分类" width="50">
				<template slot-scope="scope">
					{{scope.row.petApplyType == '1'?'猫':'狗'}}
				</template>
			</el-table-column>
			<el-table-column prop="categoryInfo.name" label="品种" width="80">
				<template slot-scope="scope">
					{{scope.row.categoryInfo == null?'--':scope.row.categoryInfo.name}}
				</template>
			</el-table-column>
			<el-table-column prop="epromNo" label="芯片编号" width="150">
				<template slot-scope="scope">
					{{scope.row.epromNo == null?'--':scope.row.epromNo}}
				</template>
			</el-table-column>
			<el-table-column prop="insideNo" label="脖圈号" width="150">
				<template slot-scope="scope">
					{{scope.row.insideNo == null?'--':scope.row.insideNo}}
				</template>
			</el-table-column>
			<el-table-column label="转移人" width="70" prop="transferUser">
			</el-table-column>
			<el-table-column prop="transferTime" label="转移时间">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.transferTime,'YYYY-MM-DD')}}
				</template>
			</el-table-column>
			<el-table-column prop="receiverShopId" label="接收门店">
				<template slot-scope="scope" v-if="scope.row.receiverShopId != null">
					<span v-if="scope.row.receiverShopId == '5e9412e0b2bfbc089daerr10'">驯养中心</span>
					<span v-if="scope.row.receiverShopId == '5e9412e0b2bfbc089daerr11'">小程序</span>
					<span v-if="scope.row.receiverShopId == '5e9412e0b2bfbc089daerr12'">金水区店</span>
					<span v-if="scope.row.receiverShopId == '5e9412e0b2bfbc089daerr14'">指挥中心</span>
					<span v-if="scope.row.receiverShopId == '5e9412e0b2bfbc089daerr17'">线上店</span>
					<span v-if="scope.row.receiverShopId == '5e9412e0b2bfbc089daerr18'">郑东新区店</span>
				</template>
			</el-table-column>
			<el-table-column prop="age" label="状态" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.transferStatus == 0">转移中</span>
					<span v-if="scope.row.transferStatus == -1">转移取消</span>
					<span v-if="scope.row.transferStatus == 1">转移完成</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="60" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="handelCanelClick(scope.row)" v-if="scope.row.transferStatus == 0">取消</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<page :total="page.total" :page="page.page" @change="changePage" style="margin-top: 22px;"></page>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import {
		transfering,canelTrans
	} from "@/api/purchaseApi.js"
	export default {
		props: {
			shopType: {
				type: Number,
				default: 0
			},
		},
		components: {
			page
		},
		data(){
			return{
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData:[],
				shops: [{
					value: '',
					label: '全部'
				},{
					value: '5e9412e0b2bfbc089daerr12',
					label: '金水区店'
				},{
					value: '5e9412e0b2bfbc089daerr14',
					label: '指挥中心'
				},{
					value: '5e9412e0b2bfbc089daerr18',
					label: '郑东新区店'
				},{
					value: '5e9412e0b2bfbc089daerr10',
					label: '驯养中心'
				}],
				shopId: '', //门店id
				transferStatu: 0, //状态
				transferStatus: [{
					value: -1,
					label: '转移取消'
				}, {
					value: 0,
					label: '转移中'
				}, {
					value: 1,
					label: '转移完成'
				}],
				keyword: '', //列表搜索内容
				comDate:'',  //日期
			}
		},
		mounted(){
			this.getTableData()
		},
		methods: {
			//筛选
			handelComClick(){
				this.page.page = 1;
				this.getTableData()
			},
			//取消转移
			handelCanelClick(row){
				this.$confirm('是否取消该宠物转移？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						petId:row.petId
					}
					canelTrans(params).then((res)=>{
						if(res.code == 0){
							console.log(res)
							this.$message({
								type: 'success',
								message: '已取消'
							}); 
							this.getTableData()
							this.$emit("refresh");
						}
					})
				})
			},
			//重置数据
			resetClick(){
				this.page.page = 1;
				this.keyword = '';
				this.shopId = '';
				this.transferStatu = 0;
				this.comDate = '';
				this.getTableData()
			},
			//获取数据
			getTableData(){
				let params = {
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
					keyword:this.keyword,
					receiveShopId:this.shopId,
					transferStatus:this.transferStatu,
				}
				if(this.comDate != ''){
					params.transferStartTime= new Date(this.comDate[0]).getTime() / 1000;
					params.transferStopTime= new Date(this.comDate[1]).getTime() / 1000;
				}
				if (this.shopType == 0) {
					params.shopId = '5e9412e0b2bfbc089daerr14'
				} else {
					params.shopId = this.$store.state.shopId
				}
				transfering(params).then((res)=>{
					if(res.code == 0){
						console.log('转移中列表',res)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		min-height: 762px;
		background: #fff;
		margin-top: 12px;
		font-size: 14px;
	
		.filter {
			height: 58px;
			display: flex;
			align-items: center;
	
			.sousuo {
				width: 153px;
				margin-right: 4px;
				margin-left: 16px;
			}
	
			.filterName {
				margin-left: 20px;
				margin-right: 4px;
			}
		}
	}
</style>
